<template>
    <div class="echartdiv">
        <div class="echart" :id="id"></div>
        <downloadExcel v-if="showExcle" :excleName="excleName" :dataExcle="dataArray" type="pie" name='' style="right:0"/>
    </div>
</template>
<script>
import axios from 'axios';
import downloadExcel from '@/components/downloadExcel';
export default {
    name:'mapChart',
    components:{ downloadExcel },
    data(){
         return {
            chart:'',
            provinces : {
                '上海': 'shanghai',
                '河北': 'hebei',
                '山西': 'shanxi',
                '内蒙古': 'neimenggu',
                '辽宁': 'liaoning',
                '吉林': 'jilin',
                '黑龙江': 'heilongjiang',
                '江苏': 'jiangsu',
                '浙江': 'zhejiang',
                '安徽': 'anhui',
                '福建': 'fujian',
                '江西': 'jiangxi',
                '山东': 'shandong',
                '河南': 'henan',
                '湖北': 'hubei',
                '湖南': 'hunan',
                '广东': 'guangdong',
                '广西': 'guangxi',
                '海南': 'hainan',
                '四川': 'sichuan',
                '贵州': 'guizhou',
                '云南': 'yunnan',
                '西藏': 'xizang',
                '陕西': 'shanxi1',
                '甘肃': 'gansu',
                '青海': 'qinghai',
                '宁夏': 'ningxia',
                '新疆': 'xinjiang',
                '北京': 'beijing',
                '天津': 'tianjin',
                '重庆': 'chongqing',
                '香港': 'xianggang',
                '澳门': 'aomen',
                '台湾': 'taiwan'
            },
            cityMap:{}
         }
    },
    props: {
        id:{
            type:String
        },
        dataArray: {
            type: Array | Object
        },
        optionName:{
            type: String
        },
        areaName: {
            type: String,
            default:'全国'
        },
        isShow: {
            type: Boolean,
            default:true
        },
        isShowTit: {
            type: Boolean,
            default:false
        },
        showExcle:{
            type:Boolean,
            default:false
        },
        excleName:{
            type: String,
            default:''
        }
    },
    mounted() {
        const that = this
        that.$nextTick(()=> {
            that.$axios.get('static/json/citymap.json').then((r) => {
                that.cityMap = r.data.cityMap;
                that.init();
            })
        })
    },
    watch: {
        dataArray () {
            this.init();
        }
    },
    methods: {
        mapOption(name){
            let data = this.dataArray,avag = parseInt(data[0].value/4);
            let len = parseInt(data[0].value/4).toString().length-1;
            if(len!=0){
                avag = parseInt((data[0].value/4)/Math.pow(10,len))*Math.pow(10,len);
            }
            let option = {
                title: {
                    show:this.isShowTit,
                    text: '区域热度分布图',
                    left: '0',
                    top: 10,
                    textStyle: {
                        fontSize: 14 ,
                        color: '#333'
                    }
                },
                tooltip: {
                    show: this.isShow,
                    formatter: function(params) {
                        let newParams='';
                        if(params.data){
                            newParams = params.name + '' + params.data['value']
                        }
                        return newParams;
                    },
                },
                visualMap: {
                    type: 'piecewise',
                    showLabel: !0,
                    text: ['高', '低'],
                    left: '-5',
                    // itemWidth: 20,
                    precision:0,
                    itemHeight:10,
                    itemGap:5,
                    min: 0,
                    max: data[0].value,
                    inRange: {
                        color: ['#fefbf5',"#f79c9c", '#e42e2e', '#c80f0f', '#a40e0e']
                    },
                    pieces: [
                        {min: avag*4}, // 不指定 max，表示 max 为无限大（Infinity）。
                        {min: avag*3, max: avag*4},
                        {min: avag*2, max: avag*3},
                        {min: avag, max: avag*2},
                        {min: 0, max: avag,},
                    ],
                    show: true,
                    //splitNumber: 0,
                    calculable: true,
                },
                geo: {
                  map: name,
                  zoom:1.2,
                  type: 'map',
                  mapType: name,
                  label: {
                    normal: {
                      show: false,

                    },
                    emphasis: {
                      show: true
                    }
                  },
                  itemStyle: {
                    normal: {
                      areaColor: '#fff',
                      borderWidth: 1,
                      borderColor: '#aaa',

                    },
                    emphasis: {
                      show: true,
                      areaColor: '#f5a741',
                    }
                  },
                  regions: [
                    { // 隐藏南海诸岛
                      name: '南海诸岛',
                      itemStyle: {
                        // 隐藏地图
                        normal: {
                          opacity: 0 // 为 0 时不绘制该图形
                        }
                      },
                      label: {
                        show: false // 隐藏文字
                      }
                    }
                  ]
                },
                series: [{
                  name: 'MAP',
                  zoom:1.2,
                  type: 'map',
                  mapType: name,
                  //selectedMode: 'false',//是否允许选中多个区域
                  label: {
                    normal: {
                      show: false,
                    },
                    emphasis: {
                      show: true
                    }
                  },
                  itemStyle: {
                    normal: {
                      areaColor: '#fff',
                      borderWidth: 1,
                      borderColor: '#aaa',

                    },
                    emphasis: {
                      show: true,
                      areaColor: '#f5a741',
                    }
                  },
                  geoIndex: 0,
                  data: data
                }]
            };
            return option;
        },
        loadMap(mapCode, name,isCall) {
            let that = this;
            that.$axios.get(mapCode).then(res=>{
                res.data.features.forEach(item => {
                  item.properties.name = item.properties.name.replace(/省|市|自治区|特别行政区|壮族|回族|维吾尔/g, '')
                })
                that.$echarts.registerMap(name, res.data);
                that.chart.setOption(that.mapOption(name));
            }).catch(error =>{
            //   console.log(error);
            });
        },
        init(){
            let that = this, timeFn = null;
            that.$echarts.init(document.getElementById(that.id)).dispose();
            that.chart = that.$echarts.init(document.getElementById(that.id));
            if(that.areaName=="全国"){
                that.loadMap('https://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_briefdoc_new/static/map/json/china_new.json', 'china');
            }else{
                let len = that.areaName.split('-').length;
                let name = that.areaName.split('-');
                let areaName = '';
                if(name[0] === '北京' || name[0] === '上海' || name[0] === '天津' || name[0] === '重庆'){
                    areaName = name[0];
                }else if(len >= 3){
                    areaName = name[1];
                }else{
                    areaName = name[len-1];
                }
                if(areaName in that.provinces){
                    that.loadMap('static/json/province/'+that.provinces[areaName]+'.json', areaName);
                }else if(areaName in that.cityMap){
                    that.loadMap('static/json/city/'+that.cityMap[areaName]+'.json', areaName);
                }else{
                    return
                }
            }
            that.chart.on('click', function(params) {
              if (!params.name) return false
                clearTimeout(timeFn);
                //由于单击事件和双击事件冲突，故单击的响应事件延迟250毫秒执行
                timeFn = setTimeout(function() {
                    let name = params.name; //地区name
                    if(that.areaName === '全国'){
                        that.$parent.fatherMethod(name,that.id);
                    }else{
                        let mapCode = that.provinces[name]; //地区的json数据
                        let mapCode1 = that.cityMap[name]; //地区的json数据
                        if (!mapCode1) {
                            return;
                        }
                        that.$parent.fatherMethod(that.areaName+'-'+name,that.id);
                    }
                }, 250);
            });
           window.addEventListener("resize",function(){
                that.chart.resize();
            });
        },
    },
}
</script>
<style lang="" scoped>
    .echart{width:100%;height:100%}
</style>



// WEBPACK FOOTER //
// src/components/echart/hotMapChart.vue